import * as Sentry from '@sentry/remix'
import { useEffect } from 'react'
import { RemixBrowser, useLocation, useMatches } from '@remix-run/react'
import { hydrateRoot } from 'react-dom/client'

Sentry.init({
  debug: !!window.SENTRY.SENTRY_ENABLED_DEV,
  dsn: window.SENTRY.DSN,
  tunnel: '/handle/sentry',
  tracesSampleRate: 0.01,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 0.01,
  environment: window?.SENTRY?.ENVIRONMENT,
  enabled:
    ['test', 'development'].includes(window?.SENTRY?.ENVIRONMENT) == false
      ? true
      : !!window.SENTRY.SENTRY_ENABLED_DEV,

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
  ],
})

hydrateRoot(document, <RemixBrowser />)
